import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "toast-host" }

import { computed, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { ToastifyContainer } from 'vue3-toastify';
import Toast from '@/components/common/toast/Toast.vue';
import useToast from '@/composables/useToast';
import type { ToastItem } from '@/types/toastTypes';


export default /*@__PURE__*/_defineComponent({
  __name: 'ToastHost',
  setup(__props) {

const route = useRoute();
const { allActiveToasts, consumeQueuedForNextLoad, dismiss, clearImmediateOnNavigation } = useToast();

const queuedToasts = ref<ToastItem[]>([]);

onMounted(() => {
  queuedToasts.value = consumeQueuedForNextLoad();
});

watch(
  () => route.fullPath,
  () => {
    clearImmediateOnNavigation();
  },
);

const visibleToasts = computed<ToastItem[]>(() => {
  return [...queuedToasts.value, ...allActiveToasts.value];
});

const handleClose = (id: string) => {
  dismiss(id);
  queuedToasts.value = queuedToasts.value.filter((toast) => toast.id !== id);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ToastifyContainer), {
      "clear-on-url-change": false,
      "newest-on-top": true
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleToasts.value, (toastItem) => {
      return (_openBlock(), _createBlock(Toast, {
        id: toastItem.id,
        key: toastItem.id,
        title: toastItem.title,
        description: toastItem.description,
        type: toastItem.type,
        closable: toastItem.closable,
        "auto-close": toastItem.autoClose,
        position: toastItem.position,
        draggable: toastItem.draggable,
        animation: toastItem.animation,
        "icon-class": toastItem.iconClass,
        onClose: ($event: any) => (handleClose(toastItem.id))
      }, null, 8, ["id", "title", "description", "type", "closable", "auto-close", "position", "draggable", "animation", "icon-class", "onClose"]))
    }), 128))
  ]))
}
}

})